module.exports = __webpack_public_path__ + "assets/img/securitiesSolutions-finialData.4df90472.png";